<div class="flex flex-col h-full">
  <div class="flex-auto overflow-auto relative">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

      <ng-container matColumnDef="trip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle sticky-column !min-w-[80px]">
          <span class="f-10">Viaje</span>
        </th>
        <td mat-cell *matCellDef="let element" class="text-left first-col table-text sticky-column">
          <p class="table-text-m">
            <span
              class="flex items-center px-3 cursor-pointer"
              [ngClass]="{ 'underline': hasTrip(element) }"
              (click)="hasTrip(element) && goToTrip(element)"
              [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
              <span>{{ hasTrip(element) ? element.tripId : '-' }}</span>
              <mat-icon
                *ngIf="hasTrip(element)"
                class="ml-2 icon-size-3 hover:animate-bounce"
                [svgIcon]="'heroicons_outline:rocket-launch'"
                style="color:rgb(0, 0, 0);">
              </mat-icon>
            </span>
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="routeUser">
        <th class="!min-w-[250px]" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="f-10">Ruta / Usuario</span>
        </th>
        <td mat-cell *matCellDef="let element"
            [matTooltip]="(element.subRoute?.name || '-') + ' - ' + (element.user || '-')">
          <app-user-route-display
          class="table-text f-10"
            [routeData]="{
              routeName: element?.subRoute?.name || '-',
              externalKeys: { code: element?.subRoute?.code || '' }
            }"
            [userData]="{
              name: element?.user || '-'
            }"
            [responsibleData]="{
              name: element?.subRoute?.responsibleName || '-',
              externalKeys: { code: element?.subRoute?.responsibleCode || '' }
            }"
            [displayMode]="'detailed'"
            [showRoute]="true"
            [showUser]="true"
            [showResponsible]="true"
            >
          </app-user-route-display>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle !min-w-[100px]">
          <span class="f-10">Fecha</span>
        </th>
        <td mat-cell *matCellDef="let element" class="table-text">
          <div class="text-content">
            <span class="f-10">{{ element.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="serials">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle !min-w-[120px]">
          <span class="f-10">Pedido</span>
        </th>
        <td mat-cell *matCellDef="let element" class="table-text">
          <div class="text-content">
            <app-document-navigation
              [documentType]="DocumentTypeEnum.PEDIDO"
              [documentSerial]="element.serials"
              [customClass]="'f-10'"
              [showIcon]="true">
            </app-document-navigation>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <th class="!min-w-[250px]" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="f-10">Cliente</span>
        </th>
        <td mat-cell *matCellDef="let element"
            [matTooltip]="(element.customer?.name || element.customerName || '-') + ' - ' + (element.customer?.code || getCode(element.customer) || '')">
          <div class="flex flex-col">
            <span class="font-medium f-10">{{ element.customer?.name || element.customerName || '-' }}</span>
            <span class="text-xs text-secondary f-9">{{ element.customer?.code || getCode(element.customer) || '' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="material">
        <th class="!min-w-[250px]" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="f-10">Material</span>
        </th>
        <td mat-cell *matCellDef="let element"
            [matTooltip]="(element.material?.name || element.materialName || '-') + ' - ' + (element.material?.code || element.materialCode || '')">
          <div class="flex flex-col">
            <span class="font-medium f-10">{{ element.material?.name || element.materialName || '-' }}</span>
            <span class="text-xs text-secondary f-9">{{ element.material?.code || element.materialCode || '' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="materialGroup">
        <th class="!min-w-[170px]" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="f-10">Grupo Material</span>
        </th>
        <td mat-cell *matCellDef="let element"
            [matTooltip]="element.material?.groupName || element.materialGroupName || '-'">
          <span class="f-10">{{ element.material?.groupName || element.materialGroupName || '-' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="desiredQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle !min-w-[210px]" >
          <span class="f-10">Cantidad Deseada</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.soldOriginalQuantity,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.parallelOriginalQuantity,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="soldQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-tittle !min-w-[210px]" >
          <span class="f-10">Cantidad Vendida</span>
        </th>
        <td mat-cell *matCellDef="let element" class="table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.baseQuantity,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.parallelQuantity,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="stockAtCreation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle !min-w-[210px]" >
          <span class="f-10">Stock al Momento</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.stockAtCreation,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.stockAtCreationParallel,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="confirmedQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle !min-w-[190px]" >
          <span class="f-10">Cantidad Confirmada</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.stockConfirmedBase,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.stockConfirmedParallel,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="deliveredQuantityERP">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right first-col table-tittle !min-w-[190px]" arrowPosition="before">
          <span class="f-10">Cantidad Recibida ERP</span>
        </th>
        <td mat-cell *matCellDef="let element" class="text-right first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.baseQuantityReceivedByERP,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.parallelQuantityReceivedByERP,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="deliveredQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle !min-w-[190px]" >
          <span class="f-10">Cantidad Entregada</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.deliveredBaseQuantity,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.deliveredParallelQuantity,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="invoicedQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="first-col table-tittle !min-w-[190px]" >
          <span class="f-10">Cantidad Facturada</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.invoicedBaseQuantity,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.invoicedParallelQuantity,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="commercialLostSale">
        <th mat-header-cell *matHeaderCellDef class="first-col table-tittle !min-w-[210px]" >
          <span class="f-10">Comercial</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: getCommercialLostSaleUMB(element),
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: getCommercialLostSaleUMP(element),
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="logisticLostSale">
        <th mat-header-cell *matHeaderCellDef class="first-col table-tittle !min-w-[210px]" >
          <span class="f-10">Logística</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: getLogisticLostSaleUMB(element),
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: getLogisticLostSaleUMP(element),
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="realLostSale">
        <th mat-header-cell *matHeaderCellDef class="first-col table-tittle !min-w-[210px]" >
          <span class="f-10">Real</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: getRealLostSaleUMB(element),
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: getRealLostSaleUMP(element),
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.material?.id,
                code: element.material?.code,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="lostSalePercentage">
        <th mat-header-cell *matHeaderCellDef class="first-col table-tittle !min-w-[90px]" >
          <span class="f-10">% Pérdida</span>
        </th>
        <td mat-cell *matCellDef="let element" class="first-col table-text">
          <div class="text-content">
            <span
              class="f-10"
              [class.text-red-600]="getLostSalePercentage(element) > 10"
              [class.text-yellow-600]="getLostSalePercentage(element) > 5 && getLostSalePercentage(element) <= 10">
              {{ formatPercentage(getLostSalePercentage(element)) }}
            </span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-50 dark:hover:bg-gray-800"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-8" [attr.colspan]="displayedColumns.length">
          <div class="flex flex-col items-center justify-center">
            <mat-icon class="icon-size-10 text-gray-400" svgIcon="heroicons_outline:document-magnifying-glass"></mat-icon>
            <p class="mt-2 text-secondary">No se encontraron datos de venta perdida comercial</p>
          </div>
        </td>
      </tr>
    </table>

  </div>

  <div class="border-t bg-white">
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [disabled]="isLoading$ | async"
      (page)="onPageChange($event)"
      showFirstLastButtons
      class="border-0">
    </mat-paginator>
  </div>
</div>